import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const TermsReacceptanceModal = ({ 
  show, 
  onAccept, 
  onDecline, 
  onOpenTerms,
  currentVersion 
}) => {
  const [termsViewed, setTermsViewed] = useState(false);
  const [acceptChecked, setAcceptChecked] = useState(false);

  const handleOpenTerms = () => {
    if (onOpenTerms) {
      onOpenTerms();
    }
    setTermsViewed(true);
  };

  const handleAcceptChange = (e) => {
    setAcceptChecked(e.target.checked);
  };

  const handleAccept = () => {
    if (acceptChecked && onAccept) {
      onAccept();
      // Reset state for next time
      setTermsViewed(false);
      setAcceptChecked(false);
    }
  };

  const handleDecline = () => {
    if (onDecline) {
      onDecline();
    }
    // Reset state
    setTermsViewed(false);
    setAcceptChecked(false);
  };

  return (
    <Modal 
      show={show} 
      onHide={handleDecline} 
      backdrop="static" 
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header>
        <Modal.Title>Updated Terms of Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <h5>Terms of Service Have Been Updated</h5>
          <p>
            Our Terms of Service have been updated as of <strong>{currentVersion}</strong>. 
            Please review the updated terms and confirm your acceptance to continue using JobInfoNetwork.
          </p>
        </div>

        <div className="mb-3">
          <Button 
            variant="outline-primary" 
            onClick={handleOpenTerms}
            className="d-flex align-items-center"
          >
            <span className="icon icon-external-link mr-2"></span>
            View Updated Terms of Service
          </Button>
          {termsViewed && (
            <small className="text-success d-block mt-1">
              ✓ Terms of Service viewed
            </small>
          )}
          {!termsViewed && (
            <small className="text-muted d-block mt-1">
              Please view the Terms of Service before accepting
            </small>
          )}
        </div>

        <Form.Group controlId="termsAcceptance" className="mb-3">
          <div className="custom-control custom-checkbox">
            <input
              className="custom-control-input"
              type="checkbox"
              checked={acceptChecked}
              onChange={handleAcceptChange}
              id="termsAcceptanceCheckbox"
              disabled={!termsViewed}
            />
            <label
              className="custom-control-label"
              htmlFor="termsAcceptanceCheckbox"
            >
              I have read and agree to the updated Terms of Service
            </label>
          </div>
        </Form.Group>

        {!termsViewed && (
          <div className="alert alert-info">
            <p className="mb-0">
              <strong>Note:</strong> You must view the Terms of Service before you can accept them.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          {/* <Button 
            variant="secondary" 
            onClick={handleDecline}
          >
            Not Now
          </Button> */}
          <Button 
            variant="primary" 
            onClick={handleAccept}
            disabled={!acceptChecked || !termsViewed}
          >
            Accept Terms
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsReacceptanceModal;